import * as Sentry from '@sentry/react';
import { getBrowserId } from 'utils/getBrowserId';
import { call, select } from 'redux-saga/effects';
import { attachTranslationFingerprint } from 'features/application/sagas/translationFingerprint';
import { selectCurrentSystemRole } from 'features/application/selectors';
import { SystemRole } from 'features/room/types';

export function* initSentrySaga() {
  if (process.env.NODE_ENV === 'production') {
    const systemRole: SystemRole | null = yield select(selectCurrentSystemRole);

    yield call(Sentry.init, {
      dsn: process.env.REACT_APP_SENTRY_DSN,
      integrations: [Sentry.browserTracingIntegration()],
      transport: Sentry.makeBrowserOfflineTransport(Sentry.makeFetchTransport),
      normalizeDepth: 10,
      attachStacktrace: true,
      debug: false,
      // Explicit rather than inheriting v10's default, so a default flip can't silently
      // disable logs. Discarded server-side until the SAMBA-9523 instance upgrade lands.
      enableLogs: true,
      environment: process.env.REACT_APP_ENV,
      release: process.env.REACT_APP_RELEASE_VERSION,
      maxBreadcrumbs: 500,
      beforeSend: attachTranslationFingerprint,
      // Transient Janus signaling noise while the WS reconnects; not actionable frontend signal.
      ignoreErrors: [/is the server down\?/i],

      tracesSampleRate: 1.0,
      tracePropagationTargets: [process.env.REACT_APP_API_URL as string],
      initialScope: {
        user: { id: getBrowserId() },
        // Non-system sessions carry an explicit value so an absent tag stays readable as
        // "emitted before this shipped" rather than "human".
        tags: { systemRole: systemRole ?? 'human' },
      },
    });
  }
}
